import { toast } from 'sonner';

import { useModal } from '@/hooks';
import { toastError } from '@/utils';

import { useCreateGenericMutation } from '../../../../features/slice/products/generic/generic-api-slice';
import { GenericForm } from '../generic-form.component';

export const CreateGeneric = () => {
    const [createGeneric, { isLoading }] = useCreateGenericMutation();
    const { closeModal } = useModal();

    const handleSubmit = async (values: {
        name: string;
        description: string;
    }) => {
        try {
            await createGeneric(values).unwrap();
            toast.success('Generic has been created');
            closeModal();
        } catch (error) {
            toastError(
                error,
                'CreateGeneric: handleSubmit -> Failed to create generic.',
            );
        }
    };

    return (
        <GenericForm
            initialValues={{ name: '' }}
            onSubmit={handleSubmit as any}
            isLoading={isLoading}
            title={'Create Generic'}
        />
    );
};
